import type { HTMLChakraProps } from '@chakra-ui/react-v2';
import { forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { usePromptBarContext } from '../PromptBarContext';
import { usePromptBarStyles } from '../usePromptBarStyles';

export type PromptBarTextareaProps = HTMLChakraProps<'textarea'>;

/**
 * Textarea for PromptBar.
 */
export const PromptBarTextarea: React.FC<PromptBarTextareaProps> = forwardRef<
  PromptBarTextareaProps,
  'textarea'
>(({ ...props }, ref) => {
  const { textarea } = usePromptBarStyles();

  const {
    content,
    setContent,
    isDisabled,
    isSubmitting,
    onSubmit,
    placeholder,
    isSubmissionDisabled,
    isGenerating,
  } = usePromptBarContext();

  return (
    <chakra.textarea
      sx={textarea}
      value={content}
      onChange={(e) => setContent(e.target.value)}
      resize="none"
      placeholder={placeholder}
      disabled={isDisabled}
      // Logic
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();

          if (
            !isSubmissionDisabled &&
            !isDisabled &&
            !isSubmitting &&
            !isGenerating
          ) {
            onSubmit?.();
          }
        }
      }}
      readOnly={isSubmitting}
      opacity={isSubmitting ? 0.375 : 1}
      {...props}
      ref={ref}
    />
  );
});
PromptBarTextarea.displayName = 'PromptBarTextarea';
